/**
 * Banner top-bar que avisa cuando el panel está leyendo datos seed (modo desarrollo).
 * Se controla con la env var `VITE_DATA_SOURCE`:
 *   - 'seed'  → muestra banner amarillo
 *   - 'live'  → no se renderiza
 *   - cualquier otro / undefined → muestra banner (default seguro)
 */
export function DataSourceBanner() {
  const dataSource = (import.meta.env.VITE_DATA_SOURCE as string | undefined) ?? 'seed';
  if (dataSource === 'live') return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="border-b border-amber-200 bg-amber-100 px-4 py-1.5 text-center text-xs font-medium text-amber-900"
    >
      <span aria-hidden="true">⚠️</span> Modo desarrollo · los datos son de
      ejemplo · no representan el negocio real
    </div>
  );
}
